import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ChevronLeft, ClipboardList } from "lucide-react";
import PhoneFrame from "../components/PhoneFrame.jsx";
import api from "../lib/api.js";

const FIELDS = [
  { k: "energy", l: "Energy" },
  { k: "mood", l: "Mood" },
  { k: "stress", l: "Stress" },
  { k: "back_comfort", l: "Back Comfort" },
  { k: "motivation", l: "Motivation" },
];

export default function CheckIn() {
  const nav = useNavigate();
  const [v, setV] = useState({ energy: 7, mood: 7, stress: 5, back_comfort: 7, motivation: 7 });
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    setLoading(true);
    try {
      await api.post("/checkin", v);
      toast.success("Check-in logged · +25 pts");
      setTimeout(() => nav("/home"), 600);
    } catch (e) {
      toast.error("Failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PhoneFrame>
      <div className="px-5 pt-6 pb-10">
        <button onClick={() => nav(-1)} className="text-slate-400 inline-flex items-center gap-1 text-sm" data-testid="checkin-back">
          <ChevronLeft size={16} /> Back
        </button>
        <div className="mt-4 flex items-center gap-3">
          <div className="w-12 h-12 rounded-2xl bg-[#142534] flex items-center justify-center">
            <ClipboardList size={22} color="#2fbf71" />
          </div>
          <div>
            <h1 className="ps-heading text-2xl font-bold">Daily Check-In</h1>
            <p className="text-slate-400 text-sm">How are you feeling today?</p>
          </div>
        </div>

        <div className="mt-6 space-y-5">
          {FIELDS.map((f) => (
            <div key={f.k} className="ps-card p-5">
              <div className="flex justify-between items-baseline">
                <div className="font-semibold">{f.l}</div>
                <div className="text-[#2fbf71] font-bold text-lg">{v[f.k]}/10</div>
              </div>
              <input
                data-testid={`checkin-${f.k}`}
                type="range" min="1" max="10" value={v[f.k]}
                onChange={(e) => setV({ ...v, [f.k]: +e.target.value })}
                className="ps-slider mt-3"
              />
              <div className="flex justify-between text-[10px] text-slate-500 mt-1">
                <span>Low</span><span>High</span>
              </div>
            </div>
          ))}
        </div>

        <button data-testid="checkin-submit" disabled={loading} onClick={submit} className="ps-button-primary w-full mt-6">
          {loading ? "Saving…" : "Submit Check-In · +25 pts"}
        </button>
      </div>
    </PhoneFrame>
  );
}
